__turbopack_context__.v({
  "table": "_I38aG_table",
  "tableContainer": "_I38aG_tableContainer",
  "td": "_I38aG_td",
  "th": "_I38aG_th",
});
